
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, ClipboardList } from 'lucide-react';
import DoctorHeader from '@/components/doctor/DoctorHeader';
import DoctorFooterNav from '@/components/doctor/DoctorFooterNav';

const CaseFileOverview = () => {
  return (
    <div className="min-h-screen bg-background pb-20">
      <DoctorHeader />
      
      <div className="container mx-auto p-4 pb-24 pt-20">
        <div className="flex items-center gap-2 mb-6">
          <FileText className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold">Case Files Overview</h1>
        </div>
        
        <Card>
          <CardContent className="py-10 text-center">
            <div className="flex flex-col items-center justify-center gap-4">
              <ClipboardList className="h-16 w-16 text-muted-foreground" />
              <h2 className="text-xl font-semibold">This page is not yet configured</h2>
              <p className="text-muted-foreground max-w-md">
                The case files overview feature is currently under development. 
                Please check back later for updates.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <DoctorFooterNav />
    </div>
  );
};

export default CaseFileOverview;
